/**
 * A custom hook that formats a date string into a German locale date format.
 * This hook takes an ISO date string and returns it formatted with day, full month name, and year in German format.
 * The formatted date follows the pattern "DD MMMM YYYY" (e.g., "15 Januar 2024").
 *
 * @param date The date string to be formatted (should be a valid date string that can be parsed by Date constructor).
 * @returns An object containing the formatted date string in German locale.
 *
 * @example
 * ```tsx
 * const { formattedDate } = useNewsCard('2024-01-15');
 * // formattedDate will be "15 Januar 2024"
 * ```
 */
export const useNewsCard = (date: string) => {
    const formattedDate = new Intl.DateTimeFormat('de-DE', {
        day: '2-digit',
        month: 'long',
        year: 'numeric'
        // dateStyle: 'full',
    }).format(new Date(date));

    return {formattedDate};
};